module.exports = __webpack_public_path__ + "img/arh_9.07c573b4.png";